import {getEnvironment} from "./environmantDetection";
import axios from "axios";

const getUserDetails = {
    getData(currentPath, source, shareCid) {
        let env = getEnvironment();
        if (env !== "prod.") {
            env = "." + env;
        } else {
            env = ".";
        }
        let baseUrl = "https://www" + env + "shutterfly.com/userstate/query.sfly";

        return window
            .evalUseNewAuth()
            .then(useNewAuth => {
                if (useNewAuth) {
                    return window.$sflyAuth
                        .getIdToken()
                        .then(idToken => {
                            var userDetails = window.$sflyAuth.getCurrentUser();
                            var jsonObj = {};
                            jsonObj["data"] = {
                                uid: userDetails.sfly_uid,
                                accessToken: idToken.jwtToken,
                                lastName: userDetails.family_name,
                                firstName: userDetails.given_name,
                                email: userDetails.email
                            };
                            return new Promise((resolve, reject) => {
                                jsonObj === "" ? reject("Error") : resolve(jsonObj);
                            });
                        })
                        .catch(() => {
                            const config = {
                                redirectUri: currentPath,
                                brand: "sfly",
                                source: source,
                                cid: shareCid
                            };
                            // If this is called, we are not logged in...
                            // Call sign in method
                            return window.$sflyAuth.showSignIn(config);
                        });
                } else {
                    // Use the old way of logging in
                    return axios.get(baseUrl).then(response => {
                        if (response.data.uid != undefined) {
                            return {data: response.data};
                        } else {
                            const safePath = encodeURIComponent(currentPath || "/");
                            window.location =
                                `/forwardingSignin/start.sfly?forwardToURL=${safePath}`;
                        }
                    });
                }
            })
            .catch(e => {
                // Hopefully this never happens, but if it does you should show an error message to the user.
                console.log("ERROR:", e);
                // For now redirect them to old login screen
                return axios.get(baseUrl).then(response => {
                    if (response.data.uid != undefined) {
                        return {data: response.data};
                    } else {
                        const safePath = encodeURIComponent(currentPath || "/");
                        window.location =
                            `/forwardingSignin/start.sfly?forwardToURL=${safePath}`;
                    }
                });
            });
    }
};
export default getUserDetails;
